import axios from "axios";
import { LocalService } from "./services/persistService";

const SERVER_BETABIT_BASE_API = process.env.REACT_APP_SERVER_BETABIT_BASE_API;
const SERVER_BASE_API = process.env.REACT_APP_SERVER_BASE_API;
const REQUEST_TIMEOUT = 30000;

const getToken = () => {
  const token = LocalService.getItem("accessToken");

  if (!token) {
    return null;
  }

  return token;
};

const axiosGET = async (endpoint) => {
  const token = getToken();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  try {
    const response = await axios({
      method: "get",
      url: `${SERVER_BETABIT_BASE_API + endpoint}`,
      headers: {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : null,
        "X-Timezone": timezone,
      },
      timeout: REQUEST_TIMEOUT,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      data: error?.response?.data,
      status: error?.response?.status,
    };
  }
};

const axiosPOST = (endpoint, body) => {
  const token = getToken();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return axios({
    method: "post",
    url: SERVER_BETABIT_BASE_API + endpoint,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : null,
      "X-Timezone": timezone,
    },
    data: {
      ...body,
    },
    timeout: REQUEST_TIMEOUT,
  });
};

const axiosPUT = (endpoint, body) => {
  const token = getToken();
  return axios({
    method: "put",
    url: SERVER_BETABIT_BASE_API + endpoint,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : null,
    },
    data: {
      ...body,
    },
    timeout: REQUEST_TIMEOUT,
  });
};

const axiosPATCH = (endpoint, body) => {
  const token = getToken();
  return axios({
    method: "patch",
    url: SERVER_BETABIT_BASE_API + endpoint,
    headers: {
      Accept: "application/json",
      Authorization: token ? `Bearer ${token}` : null,
    },
    data: body,
    timeout: REQUEST_TIMEOUT,
  });
};

const axiosDELETE = (endpoint) => {
  const token = getToken();
  return axios({
    method: "delete",
    url: SERVER_BETABIT_BASE_API + endpoint,
    headers: {
      Accept: "application/json",
      Authorization: token ? `Bearer ${token}` : null,
    },
    timeout: REQUEST_TIMEOUT,
  });
};

const API = {
  findOneRestaurant: (id) => {
    return axiosGET(`/restaurants/${id}`);
  },
  findRestaurantMenu: (restaurantId) => {
    return axiosGET(`/menu/public/${restaurantId}`);
  },
  addressByCep: (cep) => {
    return axiosGET(`/cep/${cep}`);
  },
  createOrder: (order) => {
    return axiosPOST(`/orders`, order);
  },
  findOrders: () => {
    return axiosGET(`/orders`);
  },
  getDistrict: (cityId, search) => {
    return axiosGET(
      `/districts?page=1&limit=100&search=${search}${cityId ? `&city_id=${cityId}` : ""}`,
    );
  },
  getCityOrState(type, stateId, cityId, search) {
    return axiosGET(
      `/${type}${stateId ? `/${stateId}` : ""}?search=${search}${cityId ? `&city_id=${cityId}` : ""}`,
    );
  },
};

export const createTempAccount = async (name) => {
  const body = {
    socialSource: "google",
    identifier: "temp",
    token: "temp",
    name: name,
    tempAccount: true,
  };
  try {
    const response = await axios({
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      method: "post",
      url: SERVER_BASE_API + "/api/v1/friend-user-auth",
      data: body,
      timeout: REQUEST_TIMEOUT,
    });

    const data = response.data.data;
    return {
      success: true,
      data,
    };
  } catch (e) {
    return {
      success: false,
      error: e,
    };
  }
};

export default API;
